// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Route, Routes, Navigate } from "react-router-dom";

import { ExtendedRoute } from "containers/ExtendedRoute";
import { RedirectById } from "containers/Layout/SideMenu/redirect/RedirectById";
import { RedirectDependingOnRoles } from "containers/Layout/SideMenu/redirect/RedirectDependingOnRoles";
import { trans } from "src/translations";

import { PATHS } from "./constants";
import { ManifestDetails } from "./ManifestDetails/ManifestDetails";
import { AppManifestForm } from "./ManifestForm/AppManifestForm";
import { ManifestList } from "./ManifestsList";
import { getCreatePath } from "./utils";

export function AppManifestsRoute() {
  return (
    <Routes>
      <Route index element={<RedirectDependingOnRoles />} />
      <Route
        exact
        path="/list"
        element={<ExtendedRoute component={ManifestList} />}
      />
      <Route exact path="/create" element={<Navigate to={getCreatePath()} />} />
      <Route
        exact
        path="/create/:tabId"
        element={
          <ExtendedRoute
            name={trans.APP_MANIFESTS_CREATE_ROUTE_NAME()}
            component={AppManifestForm}
          />
        }
      />
      <Route
        exact
        path="/edit/:id"
        element={
          <RedirectById
            path={PATHS.edit.replace(":tabId", PATHS.editDefaultTab)}
          />
        }
      />
      <Route
        exact
        path="/edit/:id/:tabId"
        element={
          <ExtendedRoute
            name={trans.APP_MANIFESTS_EDIT_ROUTE_NAME()}
            component={AppManifestForm}
          />
        }
      />
      <Route
        exact
        path="/details/:id"
        element={
          <RedirectById
            path={PATHS.details.replace(":tabId", PATHS.detailsDefaultTab)}
          />
        }
      />
      <Route
        exact
        path="/details/:id/:tabId"
        element={
          <ExtendedRoute
            name={trans.APP_MANIFESTS_DETAILS_ROUTE_NAME()}
            component={ManifestDetails}
          />
        }
      />
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  );
}
